import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import * as React from 'react';
export default {
  Link,
  GatsbyImage,
  getImage,
  React
};